import { render, staticRenderFns } from "./PageHiddenTip.vue?vue&type=template&id=9da8d484&scoped=true&"
import script from "./PageHiddenTip.vue?vue&type=script&lang=js&"
export * from "./PageHiddenTip.vue?vue&type=script&lang=js&"
import style0 from "./PageHiddenTip.vue?vue&type=style&index=0&id=9da8d484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da8d484",
  null
  
)

export default component.exports